import { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { IssueEntity } from '@/entities/issue.entity';
import { StaffEntity } from '@/entities/staff.entity';
import moment from 'moment';
import { mapGetters } from 'vuex';
import VueI18n from 'vue-i18n';

const joins = ['staff', 'type'];

type IssueFilterValue =
  | 'myQuestionBox'
  | 'supporting'
  | 'unResolved'
  | 'solved'
  | 'all';

@Component<IssueListMixin>({
  watch: {
    filterValue(value: IssueFilterValue) {
      switch (value) {
        case 'myQuestionBox':
          this.filter = [['staffId', '$eq', this.currentStaff.id]];
          break;
        case 'supporting':
          this.filter = [
            ['isSupported', '$eq', 'true'],
            ['staffId', '$ne', this.currentStaff.id],
            ['isResolved', '$eq', 'false'],
            ['expiredTime', '$gte', moment().format('YYYY-MM-DD HH:mm:ss')],
          ];
          break;
        case 'unResolved':
          this.filter = [['isResolved', '$eq', 'false']];
          break;
        case 'solved':
          this.filter = [['isResolved', '$eq', 'true']];
          break;
        default:
          this.filter = [];
      }
    },
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class IssueListMixin extends CreateListDataMixin<IssueEntity>(
  'issue',
  'issue',
  joins,
) {
  // items: IssueEntity[] = []

  @Prop({
    type: Array as PropType<[string, string, any][]>,
    default(): any[] {
      return [];
    },
  })
  issueFilter: [string, string, any][];

  currentStaff!: StaffEntity;

  filterValue: IssueFilterValue = 'all';

  get filterItems(): {
    text: VueI18n.TranslateResult;
    value: IssueFilterValue;
  }[] {
    return [
      {
        text: this.$t('issue.myQuestionBox'),
        value: 'myQuestionBox',
      },
      {
        text: this.$t('issue.supporting'),
        value: 'supporting',
      },
      {
        text: this.$t('issue.unResolved'),
        value: 'unResolved',
      },
      {
        text: this.$t('issue.solved'),
        value: 'solved',
      },
      {
        text: this.$t('common.all'),
        value: 'all',
      },
    ];
  }
}
